/* eslint-disable import/prefer-default-export */
export const editTemplateFormValuesSelector = (state) =>
  state.forms.template.edit
